import { headers, baseUrl } from '../common/credentials.js';

export const port = "3100";

export const getExcelSheetdata = () => {
    let url = baseUrl + port + "/api/v2/user_modules/api/excel_sheet/";
    return ([headers, url]);
}